import Rellax from 'rellax';

document.addEventListener('DOMContentLoaded', function () {
    let rellax = new Rellax('.rellax');
});
